import { useNavigate, useParams } from 'react-router-dom';
import { Triage, triageConstants } from '../../data/types/triage.types';
import { useEffect, useState } from 'react';
import { SmartForm } from '../../components/formFields/Form';
import { TextField } from '../../components/formFields/TextField';
import { Spinner } from '../../components/spinner/Spinner.component';
import toast from 'react-hot-toast';
import { api } from '../../data/api';
import { forcedNumber } from '../../helpers/general.helper';
import { useEspecialidades } from '../../data/hooks/useEspecialidades.hook';
import { MultiSelectDropdown } from '../../components/formFields/multiselectDropdown/MultiselectDropdown';
import { CheckField } from '../../components/formFields/checkField/CheckField';
import { useQueryClient } from '@tanstack/react-query';
 
interface Entity extends Triage {especialidadesIds: string[]}
const entityConstants = triageConstants
 
export const TriageForm = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
 
	const { data: dataEspecialidades, isPending, isError, error } = useEspecialidades();
 
	const [formData, setFormData] = useState<Partial<Entity>>({
		nombre: '',
		id: 0,
		especialidadesIds: [],
		activo: true,
	});
 
	const [loading, setLoading] = useState(!!id);
	const [errors, setErrors] = useState<Record<string, string>>({});
 
	useEffect(() => {
		if (id) {
		  const loadData = async () => {
			try {

				setLoading(true);
				const {data} = await api.get<Entity[]>(`${entityConstants.apiEndpoint}/${id}`);
			  	const response: Entity = data[0];
			  	setFormData({
				nombre: response.nombre,
				id: forcedNumber(response.id),
				especialidadesIds: JSON.parse(response.especialidades).map((id: number) => id.toString(10)) || [],
				especialidades: response.especialidades,
				activo: response.activo,
			  });
			} catch (err) {
			  console.error("### error", err);
			  toast.error(`Error cargando ${entityConstants.entityLabelGender === 'M' ? 'el' : 'la'} ${entityConstants.entityLabel.toLowerCase()}`);
			} finally {
			  setLoading(false);
			}
		  };
		  loadData();
		}
	}, [id]);
 
	const validateForm = () => {
		return true;
	};
 
	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
	 
		if (!validateForm()) return;

		try {
		  if (id) {
			await api.post(`${entityConstants.apiEndpoint}/${id}`, formData);
		  } else {
			await api.post(entityConstants.apiEndpoint, formData);
		  }
		  toast.success(`${entityConstants.entityLabel} ${entityConstants.entityLabelGender === 'M' ? ' guardado' : ' guardada'}`);
		  queryClient.invalidateQueries({queryKey: ['triage']});
		  navigate(entityConstants.navigateToParent);
		} catch (err) {
		  console.error("### error", err);
		  toast.error(`Error guardando ${entityConstants.entityLabel}`);
		}
	}
 
	if (loading) return <Spinner />
 
	return (
		<SmartForm
			title={id ? `Editar ${entityConstants.entityLabel}` : `Nuevo ${entityConstants.entityLabel}`}
			onSubmit={handleSubmit}
			cancelButtonNavigateTo={entityConstants.navigateToParent}
			confirmButtonLabel={id ? 'Actualizar' : 'Crear'}
		>
			<TextField
				label="Mensaje de Triage"
				value={formData.nombre || ''}
				onChange={(value) => setFormData({ ...formData, nombre: value })}
				error={errors.name}
				placeholder="Ej: Me siento mal hace poco"
			/>
 
			<MultiSelectDropdown 
				label='Especialidades'
				options={dataEspecialidades?.map(d => ({
					id: d.id.toFixed(0),
					label: d.nombre
				})) as any || []}
				// value={[]}
				value={formData.especialidadesIds || []}
				onChange={(value) => setFormData({
					...formData, 
					especialidadesIds: value,
					especialidades: JSON.stringify(value)
				})}
			/>

			<CheckField
				label="Activo"
				checked={formData.activo || false}
				onChange={(value) => setFormData({ ...formData, activo: value })}
				error={errors.activo}
			/>
		</SmartForm>
	)
 
}